/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
const c=["freehand","hybrid","click"],e="click";export{e as defaultDrawingMode,c as drawingModes};
